import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3673c2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import {computed} from 'vue'

interface AspectRatioProps {
	width?: string | number;
	ratio?: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AspectRatio',
  props: {
    width: {},
    ratio: {}
  },
  setup(__props: any) {

const props = __props
const style = computed(() => {
	const style: any = {}
	if (props.width) {
		let width = props.width + ''
		if (width.includes('%')) {
			style.width = width
		} else if (width.includes('px')) {
			style.width = width
		} else {
			style.width = width + 'px'
		}
	}
	if (props.ratio) {
		let ratio = props.ratio + ''
		if (!ratio.includes('%')) {
			ratio = (parseFloat(ratio) * 100).toFixed(2) + '%'
		}
		style['--aspect-ratio'] = ratio
	}
	return style
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["aspect-ratio", _ctx.ratio?['enable-ratio']:[]]),
    style: _normalizeStyle(style.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 6))
}
}

})